//TODO: This is should be removed when fixed on Chameleon

document.addEventListener('click', function(event) {
  var button = document.getElementById('user-dropdown-button')
  var dropdownMenu = button.nextElementSibling;

  if (event.target.parentElement === button) {
    dropdownMenu.classList.toggle('visible');
  } else {
   dropdownMenu.classList.remove('visible');
  }
})
